import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux"
import { translate } from '../Services/translation';
import { Tabs, Tab } from '@material-ui/core';
import colors from 'Exports/colors.scss';

const SearchResultTabs = (props) => {
    const { showCategoryTab, showPagesTab } = props;
    const [value, setValue] = useState('products'); 

    const handleChange = (e, newValue) => {
        setValue(newValue);
        toggleWrapperClass(newValue);
    }

    const toggleWrapperClass = (newValue) => {
        var searchResultRef = document.getElementById('search-result-content');
        searchResultRef.classList.remove(...searchResultRef.classList);
        searchResultRef.classList.add('search-result-content', 'search-result-content__' + newValue);
    }

    const StyledTab = (props) => <Tab {...props} textColor={'inherit'}/>

    return(
        <div>
            <div className="row">
                <Tabs 
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto">
                    <StyledTab label={translate('general.products')} value={'products'}/>
                    {showCategoryTab && showCategoryTab != 'False' && <StyledTab label={translate('general.categories')} value={'categories'}/>}
                    {showPagesTab && showPagesTab != 'False' && <StyledTab label={translate('general.pages')} value={'pages'}/>}                    
                </Tabs>
            </div>
        </div>
    )
};

export default SearchResultTabs;